import { useContext } from "react";

import AuthContext from "context/auth/authContext";
import TableContext from "context/table/tableContext";
import { useMediaQueries } from "shared/hooks/useMediaQueries";

import { useTaskGroupUpdate } from "../hooks";
import { TAB_VALUES, TableItemProps } from "../types";
import MobileCard from "./MobileCard";
import TableRow from "./TableRow";

const TableItem = ({ data, scrollHorizontal }: TableItemProps) => {
    const { isAdminManagerUser } = useContext(AuthContext);
    const { idType, detailsData } = useContext(TableContext);

    const { toMd } = useMediaQueries();

    const isSelected = detailsData && data.id === detailsData[idType];

    useTaskGroupUpdate(data.id, data.task_stats, isSelected);

    const isPendingApproval =
        data.approvable === Number(TAB_VALUES.PendingApproval);

    const isApprovalRequired = isPendingApproval && isAdminManagerUser;

    return toMd ? (
        <MobileCard
            data={data}
            isApprovalRequired={isApprovalRequired}
            isApprovalBadgeRendered={isPendingApproval}
        />
    ) : (
        <TableRow
            data={data}
            isApprovalRequired={isApprovalRequired}
            isApprovalBadgeRendered={isPendingApproval}
            isSelected={isSelected}
            scrollHorizontal={scrollHorizontal}
        />
    );
};

export default TableItem;
